import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE,

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE,

    ITrialInstitutionLaboratoryContractLoadByTrialInstitutionLaboratoryIdAction,
    ITrialInstitutionLaboratoryContractLoadByIdAction,
    ITrialInstitutionLaboratoryContractLoadFailureAction,
    ITrialInstitutionLaboratoryContractLoadSuccessAction,

    ITrialInstitutionLaboratoryContractSaveAction,
    ITrialInstitutionLaboratoryContractSaveSuccessAction,
    ITrialInstitutionLaboratoryContractSaveFailureAction,

    ITrialInstitutionLaboratoryContractCreateAction,
    ITrialInstitutionLaboratoryContractCreateSuccessAction,
    ITrialInstitutionLaboratoryContractCreateFailureAction,

    ITrialInstitutionLaboratoryContractDeleteAction,
    ITrialInstitutionLaboratoryContractDeleteSuccessAction,
    ITrialInstitutionLaboratoryContractDeleteFailureAction,

    ITrialInstitutionLaboratoryContractValidateAction,
    ITrialInstitutionLaboratoryContractValidateSuccessAction,
    ITrialInstitutionLaboratoryContractValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialInstitutionLaboratoryContract";
import { trialInstitutionLaboratoryContractApi } from "../services/trialInstitutionLaboratoryContract";

export const
    getTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdEpic = (action$): Observable<ITrialInstitutionLaboratoryContractLoadSuccessAction | ITrialInstitutionLaboratoryContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryContractLoadByTrialInstitutionLaboratoryIdAction) => {
                return trialInstitutionLaboratoryContractApi
                    .getTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId(action.trialInstitutionLaboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratoryContract, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoryContractByIdEpic = (action$): Observable<ITrialInstitutionLaboratoryContractLoadSuccessAction | ITrialInstitutionLaboratoryContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryContractLoadByIdAction) => {
                return trialInstitutionLaboratoryContractApi
                    .getTrialInstitutionLaboratoryContractById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratoryContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionLaboratoryContractEpic = (action$): Observable<ITrialInstitutionLaboratoryContractSaveSuccessAction | ITrialInstitutionLaboratoryContractSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE)
            .mergeMap((action: ITrialInstitutionLaboratoryContractSaveAction) => {
                return trialInstitutionLaboratoryContractApi
                    .setTrialInstitutionLaboratoryContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionLaboratoryContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionLaboratoryContractEpic = (action$): Observable<ITrialInstitutionLaboratoryContractCreateSuccessAction | ITrialInstitutionLaboratoryContractCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE)
            .mergeMap((action: ITrialInstitutionLaboratoryContractCreateAction) => {
                return trialInstitutionLaboratoryContractApi
                    .createTrialInstitutionLaboratoryContract(action.trialInstitutionLaboratoryId)
                    .map(response =>
                        CreateSuccess(
                            response.trialInstitutionLaboratoryContract,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialInstitutionLaboratoryContractEpic = (action$): Observable<ITrialInstitutionLaboratoryContractValidateSuccessAction | ITrialInstitutionLaboratoryContractValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE)
            .mergeMap((action: ITrialInstitutionLaboratoryContractValidateAction) => {
                return trialInstitutionLaboratoryContractApi
                    .validateTrialInstitutionLaboratoryContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialInstitutionLaboratoryContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    },
    deleteTrialInstitutionLaboratoryContractEpic = (action$): Observable<ITrialInstitutionLaboratoryContractDeleteSuccessAction | ITrialInstitutionLaboratoryContractDeleteFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE)
            .mergeMap((action: ITrialInstitutionLaboratoryContractDeleteAction) => {
                return trialInstitutionLaboratoryContractApi
                    .deleteTrialInstitutionLaboratoryContract(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    }